import wAxios from '@/plugins/w/axios/models/axios'
import type { TokenHandshakeHandler } from './types'

export const getTemplatesHandler: TokenHandshakeHandler = async params => {
	const name = String(params?.name || '').trim()
	const perPage = Number(params?.per_page) || 10
	const currentPage = Number(params?.current_page) || 1

	const { data, meta } = await wAxios.post_auth('v2/order-templates', {
		name,
		per_page: perPage,
		current_page: currentPage
	})

	return {
		result: {
			data,
			meta
		}
	}
}
